import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
	driverName: string;
}
const AssignDriverSelectNeverLoggedIn = ({ driverName }: Props) => {
	const { t } = useTranslation();

	return (
		<div className="assign-driver-select-item-never-logged-in text-ellipsis">
			<span>
				<b data-test-id="driverNotLoggedIn">{t('DRIVER_ASSIGNMENT_DROP_DOWN.NEVER_LOGGED_IN')} - </b>
			</span>
			<span data-test-id="driverName">{driverName}</span>
		</div>
	);
};

export default AssignDriverSelectNeverLoggedIn;
